// https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript

const validateEmail = (email: string | null | undefined) => {
  if (!email) {
    return false;
  }

  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
};

export default validateEmail;
